import React from 'react';
import { InputWithUnitField } from '../../../components/Form';
import { useFocusIdx } from '@bay-email/editor';
import { UseFieldConfig } from 'react-final-form';
import { t } from '@bay-email/core';

export function LetterSpacing({ label, name, config }: { label?: string; name?: string; config?: UseFieldConfig<any>; }) {
  const { focusIdx } = useFocusIdx();

  return (
    <InputWithUnitField
      label={label || t('Letter spacing')}
      name={name || `${focusIdx}.attributes.letter-spacing`}
      config={config}
      placeholder='0'
    />
  );
}
